import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { bulkEditLoadingState } from "@app/components/bulk-edit-progress-overlay/bulk-edit-loading.util";
import type {
	BulkEditLoadingPhase,
	BulkEditProgressMode,
} from "@app/components/bulk-edit-progress-overlay/bulk-edit-progress-overlay.component";

export interface BulkOperationProgressDialogData {
	total: number;
	mode: BulkEditProgressMode;
}

@Component({
	selector: "tg-bulk-operation-progress-dialog",
	templateUrl: "./bulk-operation-progress-dialog.component.html",
	styleUrls: ["./bulk-operation-progress-dialog.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkOperationProgressDialogComponent implements OnInit {
	loadingPhase: BulkEditLoadingPhase = "validating";
	loadingPercent = 0;
	failedCount = 0;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: BulkOperationProgressDialogData,
		private ref: MatDialogRef<BulkOperationProgressDialogComponent>,
		private cdr: ChangeDetectorRef
	) {}

	get total() {
		return this.data.total;
	}

	get mode() {
		return this.data.mode;
	}

	get titleKey(): string {
		switch (this.data.mode) {
			case "delete":
				return "time.bulk-delete-title";
			case "undo":
				return "time.edit-undo-title";
			default:
				return "time.bulk-dialog-title";
		}
	}

	ngOnInit(): void {
		this.ref.disableClose = true;
		this.ref.updateSize("480px");
		this.ref.addPanelClass(["mat-dialog-relative"]);
		this.setProgress(0);
	}

	setProgress(processed: number, failed = 0) {
		const state = bulkEditLoadingState(processed, this.data.total);
		this.loadingPhase = state.phase;
		this.loadingPercent = state.percent;
		this.failedCount = failed;
		this.cdr.markForCheck();
	}
}
